// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { N400A } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const TitleContainer = styled.div({
	alignItems: 'center',
	columnGap: token('space.100', '8px'),
	display: 'flex',
	marginTop: 0,
	minWidth: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Clickable = styled.div<{ isDisabled: boolean }>(
	{
		alignItems: 'center',
		columnGap: token('space.100', '8px'),
		cursor: 'pointer',
		display: 'flex',
		minWidth: 0,
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isDisabled }) =>
		isDisabled &&
		`
    color: ${token('color.text.disabled', N400A)};
    cursor: not-allowed;
    `,
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ClickableArea = styled.div<{ isDisabled: boolean }>(
	{
		cursor: 'pointer',
		flex: '1 1 auto',
		height: token('space.300', '24px'),
		margin: `0 ${token('space.100', '8px')} 0 0`,
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isDisabled }) =>
		isDisabled &&
		`
    color: ${token('color.text.disabled', N400A)};
    cursor: not-allowed;
    `,
);
